import React, { useEffect, useState } from "react";
import Page from "../../page-layout";
import { BackButton } from "../../../parhato2/src/entities";
import { copyOutline, shareSocialOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import { useAuth } from "../../../contexts/auth-context";
import { useConfig } from "../../../providers/config";
import { Clipboard } from "@capacitor/clipboard";
import { useGetProfileQuery } from "../../../providers/profile";
import { useTranslation } from "react-i18next";
import { Capacitor } from "@capacitor/core";
import { shareApp } from "../../../utils/shareApp";
import classNames from "classnames/bind";
import styles from "./InviteFriend.module.scss";
import { toast } from "react-toastify";
import { Image } from "../../../components/Image/Image";
import gift from "./gift.png";
import { useHistory } from "react-router";

const cx = classNames.bind(styles);

const InviteFriendPage = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const { user } = useAuth();
  const history = useHistory();
  const [showDetails, setShowDetails] = useState(false);

  const { data: profile } = useGetProfileQuery({
    userId: user?.id,
    options: { enabled: !!user?.id },
  });

  const customerId = profile?.id ?? user?.id;

  const link = `${config.baseUrl}/customer-referrals?referralId=${customerId}`;

  const handleCopyToClipboard = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        await Clipboard.write({ string: link });
        toast.success(t("Copied to clipboard!"));
        return;
      }

      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(link);
        toast.success(t("Copied to clipboard!"));
        return;
      }

      if (document.queryCommandEnabled("copy")) {
        document.execCommand("copy");
        toast.success(t("Copied to clipboard!"));
      }
    } catch (err: any) {
      toast.error("Failed to copy: " + err);
    }
  };

  const handleShare = async () => {
    await shareApp({
      appSettings: config,
      shareTextMessageProp: link,
    });
  };

  useEffect(() => {
    if (!user) history.replace("/auth");
  }, [user]);

  if (!user) return null;

  return (
    <Page className={cx("invite-friend_page")}>
      <Page.Header className="pt-[env(safe-area-inset-top)]">
        <div className={cx("header-wrapper")}>
          <div className="flex items-center justify-between ">
            <div className="flex h-14 items-center justify-center sm:h-16">
              <BackButton buttonStyles="bg-gray-200 p-2 rounded-full" iconStyles="text-2xl " />
            </div>

            <div className="flex items-center justify-center">
              <h1 className={cx("text-center font-medium text-black", "text-lg sm:text-xl lg:text-2xl")}>
                {t("Invite a friend")}
              </h1>
            </div>

            <div className="h-8 w-16" />
          </div>
        </div>
      </Page.Header>

      <Page.Content className={cx("invite-friend_content")}>
        <div
          className={cx(
            "content-wrapper",
            "flex flex-col justify-between md:justify-start py-5 md:py-0 md:gap-14 lg:gap-4",
          )}
        >
          {/* IMAGE + TEXT */}
          <div className="mt-8 sm:mt-12 md:mt-16 flex flex-col-reverse items-center justify-center gap-12 sm:gap-16 md:gap-20 lg:gap-24 xl:gap-32 md:flex-row ">
            {/* DESKTOP TEXT */}
            <div className="flex flex-col items-start gap-4 sm:gap-5 md:gap-6 lg:gap-8 md:flex">
              <div className="flex flex-col gap-2 leading-tight sm:leading-snug md:leading-none">
                <h2 className={cx("font-bold text-gray-900", "MainText")}>Приглашайте друзей и получайте баллы!</h2>
              </div>

              <div className="flex flex-col items-start gap-1 sm:gap-2">
                <p className="text-lg font-bold sm:text-base lg:text-lg text-gray-900 leading-relaxed">
                  {t("Referral program terms")}
                </p>
              </div>
            </div>

            {/* IMAGE */}
            <Image src={gift} className={cx("z-10 object-contain", "Gift")} alt="Gift illustration" />
          </div>

          {/* LINK CARD */}
          <div className="z-0 mb-36 flex w-full max-w-[1200px] flex-col items-center justify-center md:w-[600px] lg:w-[900px]">
            <div className="mx-auto flex w-full flex-col items-center justify-center gap-4 rounded-3xl bg-white p-4 shadow-[0_0_15px_rgba(0,0,0,0.2)] lg:gap-5">
              <div className="text-center font-bold text-gray-600 md:text-[1.2rem] lg:text-[1.7rem]">
                Ваша реферальная ссылка
              </div>

              {/* LINK BOX */}
              <div
                className="relative flex h-12 w-full items-center justify-between rounded-xl bg-[#EDEDED] p-3 lg:h-16 "
                onClick={handleCopyToClipboard}
              >
                <span
                  className={cx(
                    "max-w-[290px] text-ellipsis whitespace-nowrap text-center text-sm font-bold text-[#9F9F9F] lg:text-[1.2rem]",
                    "Link",
                  )}
                >
                  {link}
                </span>

                <button className="pt-1">
                  <IonIcon icon={copyOutline} className="text-gray-600" />
                </button>
              </div>
              <button
                className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-primary py-4 text-black lg:text-[1.3rem]"
                onClick={handleShare}
              >
                {t("Share")}
                <IonIcon icon={shareSocialOutline} />
              </button>
            </div>
          </div>
        </div>
      </Page.Content>
    </Page>
  );
};

export default InviteFriendPage;
